<template>
  <div>
    <div class="services-section-1 position-relative">
      <picture>
        <!-- Default image for large screens -->
        <source media="(min-width: 768px)" srcset="@/assets/services-pg-img/Services-banner.jpg" />
        <!-- Smaller image for smaller screens -->
        <img src="@/assets/services-pg-img/Services-banner-mobile.jpg" alt="Hero Section" class="img-fluid" />
      </picture>
      <div class="overlay-text position-absolute text-white text-start">
        <h1 class="display-5 fw-bold">"Building Infrastructure, Transforming Lives"</h1>
        <p class="lead">
          Our services ensure clean, reliable, and efficient water
          distribution for urban, rural, and industrial needs.
        </p>
      </div>
    </div>




    <div class="services-section-2">
      <p> At <span>Pratima Construction,</span></p>
      <p>
        we offer a comprehensive range of
        services designed to meet your water and resource management needs. From
        cutting-edge technology to tailored support, we ensure top-tier
        solutions for every project.
      </p>
    </div>
    <div class="services-section-3">
      <div class="row">
        <div class="col-lg-5 col-sm-12 text-content">
          <img src="@/assets/services-pg-img/water-supply.jpg" alt="Water Supply" class="img-fluid" />
        </div>
        <div class="col-lg-7 col-sm-12">
          <h4>Water Supply Schemes</h4>
          <p>
            Water Supply Schemes are comprehensive systems designed to collect, treat, store, and distribute potable (drinkable) water to various consumers, including households, businesses, and industrial sectors. The key components of water supply schemes include:
          </p>
          <ul>
            <li>Water Sourcing</li>
            <li>Water Treatment</li>
            <li>Pumping Stations</li>
            <li>Distribution Network</li>
            <li>Monitoring and Maintenance</li>
          </ul>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-5 order-lg-2 col-sm-12">
          <img src="@/assets/services-pg-img/Elevated-service.jpg" alt="ESR" class="img-fluid" />
        </div>
        <div class="col-lg-7 order-lg-1 col-sm-12">
          <h4>Elevated Service Reservoirs (ESRs)</h4>
          <p>
            Key infrastructure components in water supply schemes. They are large, elevated tanks or reservoirs designed to store treated water at a height, which allows gravity to facilitate the efficient distribution of water to consumers. Here's a detailed breakdown of their role and benefits
          </p>
          <ul>
            <li>Storage and Pressure Maintenance</li>
            <li>Water Distribution</li>
            <li>Construction and Design</li>
            <li>Maintenance and Inspections</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-sm-12 text-content">
          <img src="@/assets/services-pg-img/Sewage.jpg" alt="Water Supply" class="img-fluid" />
        </div>
        <div class="col-lg-7 col-sm-12">
          <h4>Sewage Water Treatment Services</h4>
          <p>
            Sewage treatment involves the removal of contaminants from wastewater to produce effluent (treated water) that can be safely discharged into the environment or reused for non-potable purposes. Construction companies specializing in sewage water treatment provide the design, installation, and maintenance of treatment plants and associated infrastructure. 
          </p>
          <ul>
            <li>Sludge Treatment and Disposal</li>
            <li>Disinfection</li>
            <li>Effluent Discharge or Reuse</li>
          </ul>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-5 order-lg-2 col-sm-12">
          <img src="@/assets/services-pg-img/Head-work.jpg" alt="ESR" class="img-fluid" />
        </div>
        <div class="col-lg-7 order-lg-1 col-sm-12">
          <h4>Head Work</h4>
          <p>
            To prevent water required for canals from passing the headworks at a level below that at which it can be utilized and to prevent any flow downstream. To raise the level of the supply so that it can irrigate the area more efficiently. There are two primary types of headworks:
          </p>
          <ul>
            <li>Diversion Headworks</li>
            <li>Storage Headworks</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-sm-12 text-content">
          <img src="@/assets/services-pg-img/network-line.jpg" alt="Water Supply" class="img-fluid" />
        </div>
        <div class="col-lg-7 col-sm-12">
          <h4>Network of Distribution lines</h4>
          <p>
            A distribution network comprises interconnected pipelines that deliver essential services like water from central sources to end-users. water distribution network is an intricate system of pipelines, storage facilities, and related components designed to deliver potable water from treatment plants or wells to consumers, meeting residential, commercial, industrial, and firefighting needs.
          </p>
          <ul>
            <li>Storage Facilities</li>
            <li>Pumping Stations</li>
            <li>Valves and Hydrants</li>

          </ul>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-5 order-lg-2 col-sm-12">
          <img src="@/assets/services-pg-img/wet-well.jpg" alt="ESR" class="img-fluid" />
        </div>
        <div class="col-lg-7 order-lg-1 col-sm-12">
          <h4>Wet Well</h4>
          <p>
            A wet well is a crucial component of a pumping station, serving as a basin where wastewater or storm water accumulates before being pumped to higher elevations or treatment facilities. Its primary function is to regulate the flow of water, ensuring that pumps operate efficiently and effectively.
          </p>
          <p>Key Functions of a Wet Well:</p>
          <ul>
            <li>Flow Regulation</li>
            <li>Pump Activation</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-sm-12 text-content">
          <img src="@/assets/services-pg-img/Rising-Main.jpg" alt="Water Supply" class="img-fluid" />
        </div>
        <div class="col-lg-7 col-sm-12">
          <h4>Rising Main</h4>
          <p>
            a pressurized pipeline that transports wastewater or sewage from a pumping station to a treatment facility or a higher elevation within the sewerage system. These pipelines are essential in overcoming topographical challenges where gravity flow is insufficient.
          </p>
          <ul>
            <li>Design and Installation</li>
            <li>Maintenance and Inspection</li>
            <li>Repair and Rehabilitation</li>
            <li>Monitoring and Risk Management</li>
          </ul>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-5 order-lg-2 col-sm-12">
          <img src="@/assets/services-pg-img/pumping-sations.jpg" alt="ESR" class="img-fluid" />
        </div>
        <div class="col-lg-7 order-lg-1 col-sm-12">
          <h4>Pumping  Stations</h4>
          <p>
            A water distribution network is a system of pipelines, storage facilities, and components that deliver potable water from treatment plants to meet residential, commercial, industrial, and firefighting needs. It involves routine maintenance, emergency response, system upgrades, and monitoring.
          </p>
          <p>Services Provided by Pumping Stations:</p>
          <ul>
            <li>Routine Maintenance</li>
            <li>Emergency Response</li>
            <li>System Upgrades</li>
            <li>Monitoring and Control</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


  
  <script>
  // Import the Navbar component
  
  export default {
    name: 'ServicePage',

  };
  </script>
  
  <style scoped>
  /* General styles */
  /* service section 1 */
  .services-section-1 {
  position: relative;
  max-width: 100%;
}

.services-section-1 img {
  width: 100%;
  height: auto;
}

.services-section-1 .overlay-text {
  position: absolute;
  bottom: 5%;
  left: 5%;
  padding: 73px 0px;
  border-radius: 8px;
  max-width: 80%;
  padding-right: 48vh; /* Default padding for large screens */
}

.services-section-1 .overlay-text h1 {
  font-weight: 600;
  font-size: 64px;
  line-height: 119%;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Inter';
}

.services-section-1 .overlay-text p {
  font-weight: 400;
  font-size: 22px;
  line-height: 136%;
  color: #fff;
  font-family: 'Inter';
  padding-right: 38vh; /* Default padding for large screens */
}

@media (max-width: 1384px) {
  .services-section-1 .overlay-text {
    padding-right: 3vh; /* Adjust padding for slightly smaller screens */
  }

  .services-section-1 .overlay-text h1 {
    font-size: 58px; /* Adjust font size */
  }

  .services-section-1 .overlay-text p {
    font-size: 20px; /* Adjust paragraph font size */
    padding-right: 40vh; /* Adjust padding */
  }
}

/* Medium screens (1024px and smaller) */
@media (max-width: 1024px) {
  .services-section-1 .overlay-text {
    padding-right: 30vh;
    padding: 50px 0px;
  }

  .services-section-1 .overlay-text h1 {
    font-size: 48px;
  }

  .services-section-1 .overlay-text p {
    font-size: 18px;
    padding-right: 25vh;
  }
}


/* Adjustments for smaller screens */
@media (max-width: 768px) {
  .services-section-1 .overlay-text {
    bottom: 10%;
    left: 3%;
    padding: 15px;
  }

  .services-section-1 .overlay-text h1 {
    font-size: 28px;
    line-height: 1.3;
  }

  .services-section-1 .overlay-text p {
    font-size: 16px;
    padding-right: 13vh;
  }
}

@media (max-width: 576px) {
  .services-section-1 .overlay-text {
    bottom: 8%;
    left: 2%;
    padding: 10px;
  }

  .services-section-1 .overlay-text h1 {
    font-size: 24px;
  }

  .services-section-1 .overlay-text p {
    font-size: 14px;
    padding-right: 3vh;
  }
}

@media (max-width:352px) {
  .services-section-1 .overlay-text h1 {
    font-size: 21px !important;
  }

  .services-section-1 .overlay-text p {
    font-size: 12px;
    padding-right: 3vh;
  }
}


/* services section 2 */

.services-section-2 {
  font-weight: 400;
  font-size: clamp(20px, 2.5vw, 36px);
  line-height: 144%;
  text-align: left;
  font-family: 'Archivo';
  padding: 0 10vw;
  margin-bottom: 15vh;
  margin-top: 15vh;
}

.services-section-2 p{
  margin-bottom: 0px;
}

.services-section-2 span {
  color: #197dca;
}

@media (max-width:991px) {
  .services-section-2{
    margin-bottom: 8vh;
    margin-top: 8vh;
  }
}

.services-section-3 {
  padding: 0 10vw;
}

.services-section-3 .row {
  align-items: flex-start; /* Align items to the start */
  margin-bottom: 5vh;
}

.services-section-3 .row img {
  width: 525px; /* Explicit width */
  height: 451px; /* Explicit height */
  object-fit: cover; /* Ensures the image maintains aspect ratio without distortion */
  margin-bottom: 2vh;
}

.services-section-3 h4 {
  font-weight: 700;
  font-size: clamp(1.5rem, 2vw, 2.25rem);
  font-family: 'Archivo';
  margin-bottom: 1rem;
  text-align: left;
}

.services-section-3 p {
  font-size: clamp(16px, 2.5vw, 24px);
  font-family: 'Inter';
  line-height: 1.5;
  text-align: left;
}

.services-section-3 ul {
  list-style: disc;
  padding: 0;
  padding-left: 6vh;
  text-align: left;
}
.services-section-3 .row .text-content {
  display: flex;
  flex-direction: column; /* Ensure text items stack vertically */
  justify-content: flex-start; /* Align content to the top */
}

.services-section-3 ul li {
  font-size: clamp(16px, 2.5vw, 24px);
  margin-bottom: 0.5rem;
  font-family: 'Inter';
}

.services-section-3 img{
  border-radius: 25px;
}

@media (max-width: 991px) {
  .services-section-3 {
    padding: 0 5vw;
  }

  .services-section-3 .row {
    flex-direction: column;
  }

  .services-section-3 h4,
  .services-section-3 p {
    text-align: left;
  }

  .services-section-3 .row img {
    width: 100%; /* Ensures responsiveness */
    height: auto; /* Adjust height automatically for smaller screens */
  }
}

@media (max-width: 576px) {
  .services-section-3 .row img {
    margin: 0 auto;
    margin-bottom: 4vh;
  }

}

.services-section-1 .overlay-text h1 {
  font-size: 64px; /* Default */
  line-height: 119%;
  font-weight: 600;
}

.services-section-1 .overlay-text p {
  font-size: 22px; /* Default */
  line-height: 136%;
  font-weight: 400;
}

@media (max-width: 992px) { /* Tablet */
  .services-section-1 .overlay-text h1 {
    font-size: 48px;
  }

  .services-section-1 .overlay-text p {
    font-size: 20px;
  }
}

@media (max-width: 768px) { /* Mobile */
  .services-section-1 .overlay-text h1 {
    font-size: 36px;
  }

  .services-section-1 .overlay-text p {
    font-size: 18px;
  }
}

@media (max-width: 576px) { /* Small Mobile */
  .services-section-1 .overlay-text h1 {
    font-size: 28px;
  }

  .services-section-1 .overlay-text p {
    font-size: 16px;
  }
}

@media (min-width: 1200px) { /* Large screens */
  .services-section-1 .overlay-text h1 {
    font-size: 64px; /* Bigger for large screens */
  }

  .services-section-1 .overlay-text p {
    font-size: 28px; /* Bigger for large screens */
  }
}



</style>
